<template>
	<div
		id="user-detail"
		:class="[!isWeb ? 'mobile-user-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToUsers()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Adicionar Usuário' : 'Editar Usuário' }}
			</h1>
		</div>
		<UserForm :isWeb="isWeb" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import UserForm from '@/components/modules/User/UserDetail/UserForm/UserForm.vue';

export default {
	name: 'UserDetail',
	components: { SidebarArrow, UserForm },
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	created() {},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToUsers() {
			const investorId = this.$route.query.investorId;

			if (investorId) {
				this.$router.push({
					path: '/dashboard/investor/detail',
					query: { id: investorId },
				});
			} else {
				this.$router.push({ path: '/dashboard/users' });
			}
		},
	},
	computed: {
		...mapGetters('userManagement', ['isLoadingUsers']),
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'UserDetail.scss';
</style>
